import { spawn } from "redux-saga/effects";
import { medicationSaga } from "store/medication/medication.saga";

export function* rootSaga() {
  yield spawn(medicationSaga);
}
